import { USER_ROLE } from "./enums";

export const determineUserRole = (role) => {
	const userRoles = Array.isArray(role) ? role : [];
	return userRoles.includes(USER_ROLE.SUPER_ADMIN)
		? USER_ROLE.SUPER_ADMIN
		: userRoles.includes(USER_ROLE.ADMIN)
		? USER_ROLE.ADMIN
		: userRoles.includes(USER_ROLE.INSTRUCTOR)
		? USER_ROLE.INSTRUCTOR
		: USER_ROLE.USER;
};

export const formatRoleLabel = (role) => {
	if (role === USER_ROLE.SUPER_ADMIN) return 'Super Admin';
	return role.charAt(0).toUpperCase() + role.slice(1);
};
